/**
 * News Feed — AJAX Load More.
 */

(function () {
    'use strict';

    const ROOT = '[data-news-feed]';

    function getAjaxUrl() {
        if (window.sojTheme && window.sojTheme.ajaxUrl) {
            return window.sojTheme.ajaxUrl;
        }
        return '/wp-admin/admin-ajax.php';
    }

    function initBlock(root) {
        const list = root.querySelector('[data-news-feed-list]');
        const button = root.querySelector('[data-news-feed-more]');
        if (!list || !button) {
            return;
        }

        let loading = false;

        button.addEventListener('click', async () => {
            if (loading || button.disabled) {
                return;
            }

            loading = true;
            button.disabled = true;
            button.classList.add('is-loading');

            const page = Number(root.dataset.page || '1') + 1;
            const perPage = Number(root.dataset.perPage || '9');
            const skipFirst = root.dataset.skipFirst === '1' ? '1' : '0';
            const nonce = root.dataset.nonce || '';

            const body = new FormData();
            body.append('action', 'soj_news_feed_load_more');
            body.append('nonce', nonce);
            body.append('page', String(page));
            body.append('per_page', String(perPage));
            body.append('skip_first', skipFirst);

            try {
                const response = await fetch(getAjaxUrl(), {
                    method: 'POST',
                    credentials: 'same-origin',
                    body,
                });
                const payload = await response.json();

                if (!payload || !payload.success || !payload.data) {
                    throw new Error('Load more failed');
                }

                if (payload.data.html) {
                    list.insertAdjacentHTML('beforeend', payload.data.html);
                }

                root.dataset.page = String(page);

                if (!payload.data.has_more) {
                    const wrap = button.closest('.load-more-wrap');
                    if (wrap) {
                        wrap.remove();
                    } else {
                        button.remove();
                    }
                    return;
                }

                button.disabled = false;
            } catch (error) {
                button.disabled = false;
                if (window.sojTheme && window.sojTheme.debug) {
                    console.error(error);
                }
            } finally {
                loading = false;
                button.classList.remove('is-loading');
            }
        });
    }

    function init() {
        document.querySelectorAll(ROOT).forEach(initBlock);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
